import styled from 'styled-components';
import { COLOR, TYPOGRAPHY } from '../../../theme/constants';
import { FlexContainer } from '@emarketer/componentlibrary';

export const CollectionPickerWrapper = styled.div``;

export const CollectionPickerMobileWrapper = styled.div`
  @media only screen and (min-width: 1200px) {
    display: none;
  }
`;

export const CollectionPickerMobileOverlay = styled.div`
  position: fixed;
  background: rgba(0, 0, 0, 0.4);
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
`;

export const CollectionPickerContainer = styled.div<{ active: boolean }>`
  position: absolute;
  left: 10px;
  z-index: 30;
  border-top: 0px;
  background-color: ${COLOR.WHITE};
  margin-top: -15px;
  width: calc(100% - 20px);

  @media only screen and (min-width: 1200px) {
    position: static;
    margin: 0;
    min-height: 350px;
    width: 100%;
  }

  @media (max-width: 1200px) {
    border: 1px solid ${COLOR.LIGHTGREY};
    border-radius: 4px;
    background: ${COLOR.WHITE};
    z-index: 100;
    width: calc(100% - 49px);
    margin: 0 14px;
    border-top: none;
  }
`;

export const CollectionPickerTemplateGroup = styled(FlexContainer)<{ active: boolean }>`
  max-height: 75vh;
  overflow: auto;
  ${(props) => (props.active ? 'display: none !important;' : '')}
  padding: 24px;

  @media only screen and (min-width: 1200px) {
    max-height: none;
    display: flex !important;
  }

  @media (max-width: 1200px) {
    max-height: none;
    overflow: none;
  }
`;

export const MetaCollectionWrapper = styled.div``;

export const CollectionTitle = styled.div`
  display: none;
  text-decoration: none;
  font-size: 18px;
  min-height: 45px;
  padding: 10px 10px 10px 0px;
  margin: 10px 10px 0 10px;
  padding-bottom: 9px;
  color: ${COLOR.RED};
  border-bottom: 1px solid #ccc;
  ${TYPOGRAPHY.BOLD}

  @media only screen and (min-width:1200px) {
    display: block;
  }
`;
